import {
  authHeader,
  authHeaderNoToken,
  handleResponse
} from "../helper/auth-header";

export default class BrandService {
  ControllerName = "BrandMaster";

  async GetBrandsDDL() {
    const requestOptions = {
      method: "GET",
      headers: authHeader()
    };

    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/GetBrandsDDL`;
    const response = await fetch(url, requestOptions);
    const data = await handleResponse(response, { url, ...requestOptions });
    return data;
  }

  async GetBrandName(brandId) {
    const requestOptions = {
      method: "GET",
      headers: authHeaderNoToken()
    };

    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/GetBrandName?brandId=${brandId}`;
    const response = await fetch(url, requestOptions);
    const data = await handleResponse(response, { url, ...requestOptions });
    return data;
  }
}
